var _circle, _path, _circle2, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadContainerDirectionsSmaller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 83,
    viewBox: "0 0 30 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "url(#paint0_linear_1376_1907)",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.27 10.214h2.436L19.612 20h-2.534l-.784-2.016h-3.612L11.898 20H9.35l3.92-9.786zm2.408 5.866l-1.19-3.29-1.204 3.29h2.394z",
    fill: "url(#paint1_linear_1376_1907)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 68,
    r: 14.5,
    stroke: "url(#paint2_linear_1376_1907)",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.63 63.214h4.956c.943 0 1.685.233 2.226.7.55.467.826 1.134.826 2.002 0 .41-.093.793-.28 1.148a2.095 2.095 0 01-.798.84c.476.187.826.457 1.05.812.224.345.336.798.336 1.358 0 .597-.14 1.12-.42 1.568-.28.439-.658.775-1.134 1.008-.467.233-.99.35-1.568.35H10.63v-9.786zm4.41 3.878c.728 0 1.092-.34 1.092-1.022 0-.383-.093-.644-.28-.784-.187-.15-.471-.224-.854-.224h-1.89v2.03h1.932zm.154 4.06c.42 0 .733-.08.938-.238.205-.159.308-.439.308-.84 0-.401-.107-.69-.322-.868-.215-.187-.541-.28-.98-.28h-2.03v2.226h2.086z",
    fill: "url(#paint3_linear_1376_1907)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint4_linear_1376_1907)",
    strokeDasharray: "2 2",
    d: "M14.5 32v19"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1376_1907",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1376_1907",
    x1: 14.5,
    y1: 5,
    x2: 14.5,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1376_1907",
    x1: 15,
    y1: 53,
    x2: 15,
    y2: 83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1376_1907",
    x1: 15.5,
    y1: 58,
    x2: 15.5,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1376_1907",
    x1: 13.5,
    y1: 32,
    x2: 13.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadContainerDirectionsSmaller);
export default __webpack_public_path__ + "static/media/load-container-directions-smaller.50fa4ab669e1087f554df52cedcbbcf8.svg";
export { ForwardRef as ReactComponent };